// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__LasUl","header_title":"style_header_title__Fyr01","header":"style_header__C7HvL"};